
<template>
    <div class="bg-gray-50 w-full rounded-md flex flex-col">
        <div class="info-attr text-gray-400">
            <div class="top-container flex justify-between p-4 pb-0">
                <div class="label">{{ label }}</div>
                <div class="icon">
                    <slot></slot>
                </div>
            </div>
            <div v-if="$slots.bottom" class="bottom-container">
                <slot name="bottom"></slot>
            </div>
        </div>
        <div v-if="value != ''" class="info-value font-semibold text-ellipsis flex items-center flex-grow px-4">{{ value }}</div>
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                required: true
            },
            value: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                
            }
        },
    }
</script>

<style scoped>
 .info-value {
    min-height: 40px;
 }
</style>